

const Role_Enum = {
    ROLE_ADMIN: {'raw':'ROLE_ADMIN', friendly: 'Admin'},
    ROLE_STOCK_OFFICER: {'raw':'ROLE_STOCK_OFFICER', friendly: 'Stock Officer'},
    ROLE_STOCK_MANAGER: {'raw':'ROLE_STOCK_MANAGER', friendly: 'Stock Manager'},
    ROLE_REQUEST_APPROVER: {'raw':'ROLE_REQUEST_APPROVER', friendly: 'Request Approver'},
    ROLE_EXECUTIVE: {'raw':'ROLE_EXECUTIVE', friendly: 'Executive'},
    ROLE_USER: {'raw':'ROLE_USER', friendly: 'User'},
    ROLE_REQUESTER: {'raw':'ROLE_REQUESTER', friendly: 'Requester'},
    ROLE_TECHNICIAN: {'raw':'ROLE_TECHNICIAN', friendly: 'Technician'},
    ROLE_SALES_CLERK: {'raw':'ROLE_SALES_CLERK', friendly: 'Sales Clerk'}
}

const role_keys = Object.keys(Role_Enum);

const role_obj_array = role_keys.map((key) => {
    return {
        name: Role_Enum[key].raw,
        friendly: Role_Enum[key].friendly
    }
})

const sideMenus = [
    {
        name: 'Dashboard',
        icon: 'ni ni-shop text-primary text-sm opacity-10',
        to: '/dashboard',
        roles: [Role_Enum.ROLE_ADMIN.raw, Role_Enum.ROLE_USER.raw, Role_Enum.ROLE_REQUESTER.raw, Role_Enum.ROLE_STOCK_OFFICER.raw, Role_Enum.ROLE_STOCK_MANAGER.raw, Role_Enum.ROLE_REQUEST_APPROVER.raw, Role_Enum.ROLE_EXECUTIVE.raw],
        children: []
    },
    {
        name: 'Customers',
        icon: 'ni ni-shop text-primary text-sm opacity-10',
        to: '#',
        roles: [Role_Enum.ROLE_ADMIN.raw, Role_Enum.ROLE_EXECUTIVE.raw, Role_Enum.ROLE_REQUESTER.raw, Role_Enum.ROLE_SALES_CLERK.raw],
        children: [
            {
                name: 'All Customers',
                icon: 'ni ni-shop text-primary text-sm opacity-10',
                to: '/customers',
                // Admin/Requester only — the full list has edit/delete actions
                // a sales clerk doesn't need; clerks search + quick-create from the till instead.
                roles: [Role_Enum.ROLE_ADMIN.raw, Role_Enum.ROLE_EXECUTIVE.raw, Role_Enum.ROLE_REQUESTER.raw],
                children: []
            },
            {
                name: 'Debtors',
                icon: 'ni ni-shop text-primary text-sm opacity-10',
                to: '/debtors',
                roles: [Role_Enum.ROLE_ADMIN.raw, Role_Enum.ROLE_EXECUTIVE.raw, Role_Enum.ROLE_REQUESTER.raw, Role_Enum.ROLE_SALES_CLERK.raw],
                children: []
            }
        ]
    },
    {
        name: 'Inventory Management',
        icon: 'ni ni-shop text-primary text-sm opacity-10',
        to: '#',
        roles: [Role_Enum.ROLE_STOCK_OFFICER.raw, Role_Enum.ROLE_STOCK_MANAGER.raw],
        children: [
            {
                name:"Inventory Metadata",
                icon:"ni ni-shop text-primary text-sm opacity-10",
                to:'/inventory-metadata',
                roles:[Role_Enum.ROLE_STOCK_MANAGER.raw, Role_Enum.ROLE_STOCK_OFFICER.raw],
                children: []
            },
            {
                name:"Items",
                icon:"ni ni-shop text-primary text-sm opacity-10",
                to:'/items',
                roles:[Role_Enum.ROLE_STOCK_MANAGER.raw, Role_Enum.ROLE_STOCK_OFFICER.raw],
                children: []
            },
            // {
            //     name: 'Variants',
            //     icon: 'ni ni-shop text-primary text-sm opacity-10',
            //     to: '/item-inventories',
            //     roles: [Role_Enum.ROLE_STOCK_MANAGER.raw, Role_Enum.ROLE_STOCK_OFFICER.raw],
            //     children: []
            // },
        ]
    },
    {
        name: 'Requests',
        icon: 'ni ni-shop text-primary text-sm opacity-10',
        to: '/requests',
        roles: [Role_Enum.ROLE_REQUESTER.raw, Role_Enum.ROLE_STOCK_OFFICER.raw, Role_Enum.ROLE_STOCK_MANAGER.raw, Role_Enum.ROLE_REQUEST_APPROVER.raw, Role_Enum.ROLE_EXECUTIVE.raw],
        children: []
    },
    {
        name: 'Reports',
        icon: 'ni ni-shop text-primary text-sm opacity-10',
        to: '/reports',
        roles: [Role_Enum.ROLE_REQUESTER.raw, Role_Enum.ROLE_STOCK_OFFICER.raw, Role_Enum.ROLE_STOCK_MANAGER.raw, Role_Enum.ROLE_REQUEST_APPROVER.raw, Role_Enum.ROLE_EXECUTIVE.raw],
        children:[]
    },
    {
        name: 'Sales',
        icon: 'ni ni-shop text-primary text-sm opacity-10',
        to: '#',
        // Must match the beforeEnter guards in router/salesManagementRoutes.js —
        // both sales routes admit admin or sales clerk only, so anyone else
        // listed here would just be bounced to Unauthorized.
        roles: [Role_Enum.ROLE_ADMIN.raw, Role_Enum.ROLE_SALES_CLERK.raw],
        children:[
            {
                name: 'Sales Report',
                icon: 'ni ni-shop text-primary text-sm opacity-10',
                to: '/sales-report',
                roles: [Role_Enum.ROLE_ADMIN.raw, Role_Enum.ROLE_SALES_CLERK.raw],
                children: []
            },
            {
                name: 'Sales Management',
                icon: 'ni ni-shop text-primary text-sm opacity-10',
                to: '/sales-management',
                roles: [Role_Enum.ROLE_ADMIN.raw, Role_Enum.ROLE_SALES_CLERK.raw],
                children: []
            },
            {
                name: 'Returns',
                icon: 'ni ni-shop text-primary text-sm opacity-10',
                to: '/returns-report',
                roles: [Role_Enum.ROLE_ADMIN.raw, Role_Enum.ROLE_SALES_CLERK.raw],
                children: []
            }
        ]
    },
    {
        name: 'Users',
        icon: 'fa fa-users text-primary text-sm opacity-10',
        to: '/users',
        roles: [Role_Enum.ROLE_ADMIN.raw],
        children: []
    }  
]

export { sideMenus, Role_Enum, role_keys, role_obj_array }
